import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import UserRole from '../../../shared/AuthRoles';
import AIGuestReservationsAssistant from '../../components/Reservations/AIReservations/AIGuestReservationAssistant';
import AIReservationsAssistant from '../../components/Reservations/AIReservations/AIReservationsAssistant';

export default function AiAssistantReservationsPage() {
    const loggedInUser = UserRole();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Grid
            sx={{
                width: '100%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <Grid
                sx={{
                    width: '100%',
                    minHeight: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                {loggedInUser?.role?.includes('owner') && (
                    <AIReservationsAssistant />
                )}
                {loggedInUser?.role?.includes('guest') && (
                    <AIGuestReservationsAssistant />
                )}
            </Grid>
        </Grid>
    );
}
